// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import UnpolyLinkHelper from '../support/unpoly_link_helper'

const DEFAULT_TARGET = '.page > .content'

up.macro('[content-link]', (link) => {
  const target = link.getAttribute('content-link') || DEFAULT_TARGET

  const attrs = {
    'up-target': target,
    'up-transition': 'cross-fade',
    'up-duration': '150',
  }

  return UnpolyLinkHelper.setAttributes(link, attrs)
})
